export const statesAU = [
  {
    label: 'Victoria',
    value: 'VIC',
  },
  {
    label: 'New South Wales',
    value: 'NSW',
  },
  {
    label: 'Queensland',
    value: 'QLD',
  },
  {
    label: 'South Australia',
    value: 'SA',
  },
  {
    label: 'Western Australia',
    value: 'WA',
  },
  {
    label: 'Tasmania',
    value: 'TAS',
  },
  {
    label: 'Northern Territory',
    value: 'NT',
  },
  {
    label: 'Australian Capital Territory',
    value: 'ACT',
  },
]

export const rolePositions = [
  {
    value: 'Z7',
    label: 'Chairperson',
  },
  {
    value: 'Z8',
    label: 'Chief Executive Officer',
  },
  {
    value: 'Z9',
    label: 'Child Care Service Director',
  },
  {
    value: 'Z10',
    label: 'Company Director',
  },
  {
    value: 'Z11',
    label: 'Company Financial Officer',
  },
  {
    value: 'Z12',
    label: 'Company Secretary',
  },
  {
    value: 'Z13',
    label: 'Coordinator',
  },
  {
    value: 'Z14',
    label: 'Executive Officer',
  },
  {
    value: 'Z15',
    label: 'General Manager',
  },
  {
    value: 'Z16',
    label: 'Manager',
  },
  {
    value: 'Z17',
    label: 'Nominated Supervisor',
  },
  {
    value: 'Z18',
    label: 'Operator',
  },
  {
    value: 'Z19',
    label: 'President',
  },
  {
    value: 'Z20',
    label: 'Principal',
  },
  {
    value: 'Z21',
    label: 'Program Manager',
  },
  {
    value: 'Z22',
    label: 'Treasurer',
  },
  {
    value: 'Z23',
    label: 'Other',
  },
]

export const roleIsOther = ({ position }) => position === 'Z23'

export const businessType = [
  {
    value: 'R',
    label: 'RTO (registered training organisation)',
  },
  {
    value: 'O',
    label: 'Other business',
  },
]



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/states.js